module.exports = __webpack_public_path__ + "img/40.4ac1e5e1.png";